/**
 * Somme des unreadCount conversations Chat (messages CLIENT non lus).
 */
export function sumChatUnread(conversations = []) {
  if (!Array.isArray(conversations)) return 0;
  return conversations.reduce((sum, conv) => sum + (Number(conv?.unreadCount) || 0), 0);
}

export default sumChatUnread;
